const DEFAULT_EXPIRY_SKEW_MS = 5 * 60 * 1000;

function decodeBase64Url(value: string): string {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(
    normalized.length + ((4 - (normalized.length % 4)) % 4),
    '=',
  );

  if (typeof globalThis.atob === 'function') {
    return globalThis.atob(padded);
  }

  return Buffer.from(padded, 'base64').toString('binary');
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function getJwtExpiryMs(token: string | null | undefined): number | null {
  if (!token) return null;

  const [, payload] = token.split('.');
  if (!payload) return null;

  try {
    const parsed: unknown = JSON.parse(decodeBase64Url(payload));
    if (!isRecord(parsed)) return null;

    const exp = parsed.exp;
    if (typeof exp !== 'number' || !Number.isFinite(exp)) return null;

    return exp * 1000;
  } catch {
    return null;
  }
}

export function getMsUntilJwtExpiry(token: string | null | undefined): number | null {
  const expiryMs = getJwtExpiryMs(token);
  return expiryMs == null ? null : expiryMs - Date.now();
}

export function isTokenExpiringSoon(
  token: string | null | undefined,
  skewMs = DEFAULT_EXPIRY_SKEW_MS,
): boolean {
  const msUntilExpiry = getMsUntilJwtExpiry(token);
  return msUntilExpiry == null || msUntilExpiry <= skewMs;
}

export { DEFAULT_EXPIRY_SKEW_MS };
